__turbopack_context__.v({
  "__container": "uploader-minimal-step-module-scss-module__6v-rNW____container",
  "uploader-minimal-step": "uploader-minimal-step-module-scss-module__6v-rNW__uploader-minimal-step",
});
